const storeDisplayNames = {
  'GovX Inhouse Fulfillment': 'GXFC',
}

export const getStoreDisplayName = (storeName) =>
  storeDisplayNames[storeName] || storeName
